var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-itens',{attrs:{"itemEditar":_vm.itemEditar},on:{"adicionar":_vm.adicionarTabela,"atualizar":_vm.atualizaItemTabela}}),_c('tabela-itens',{attrs:{"items":_vm.notasFiscaisItens},on:{"editar-itens":_vm.editarItens}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }